import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import * as createOfflineInvestorTypes from 'src/actions/project/offline-investor/create/Types';
import { changeProjectData, ChangeProjectDataAction } from 'src/actions/project/change-data/ChangeProjectData.actions';
import OfflineInvestor from 'src/entities/OfflineInvestor';
import {
  createOfflineInvestor,
  CreateOfflineInvestorAction,
  CreateOfflineInvestorSuccess
} from 'src/actions/project/offline-investor/create/CreateOfflineInvestor.actions';
import {
  default as ProjectOfflineInvestorsFormComponent,
  ProjectOfflineInvestorsFormComponentProps
} from 'src/modules/project/update/partials/round-information/ProjectOfflineInvestorsForm.component';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';
import ProjectData from 'src/value-objects/ProjectData';

interface StateProps {
  error: boolean;
  errorMessage: {};
}

interface DispatchProps {
  createOfflineInvestor(projectId: string, offlineInvestor: OfflineInvestor): Promise<CreateOfflineInvestorAction>;

  changeProjectData(project: ProjectData): ChangeProjectDataAction;
}

interface OwnProps {
  project: ProjectData;
}

interface Props extends StateProps, DispatchProps, OwnProps {

}

interface State {
  success?: boolean;
  offlineInvestor?: OfflineInvestor;
}

class ProjectOfflineInvestorsFormContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      offlineInvestor: new OfflineInvestor({
        name: '',
        amountInvested: 0,
        investmentType: ''
      })
    };
  }

  public render(): React.ReactNode {
    return (
      this.props.project ?
        <ProjectOfflineInvestorsFormComponent {...this.getComponentProps()} /> :
        <LoadingContainer/>
    );
  }

  private handleChange(key: string): (value: string | File) => void {
    switch (key) {
      case 'amountInvested':
        return (
          (value: string) => {
            let newData = this.state.offlineInvestor!;
            newData.amountInvested = parseFloat(value);
            this.setState({ offlineInvestor: newData });
          }
        );
      default:
        return (
          (value: string) => {
            let newData = { ...this.state.offlineInvestor!, [key]: value };
            this.setState({ offlineInvestor: newData });
          }
        );
    }
  }

  private handleSubmit(): void {
    this.props.createOfflineInvestor(this.props.project.id.toString(), this.state.offlineInvestor!).then(
      (response: CreateOfflineInvestorSuccess) => {
        if (response.type === createOfflineInvestorTypes.CREATE_OFFLINE_INVESTOR_SUCCESS) {
          let newData = this.props.project;
          newData.offlineInvestors.push(response.payload);
          this.props.changeProjectData(new ProjectData(newData));
          this.setState({
            success: true,
            offlineInvestor: {
              name: '',
              amountInvested: 0,
              investmentType: ''
            }
          });
          document.getElementById('add-co-investor-button')!.click();          
        }
      }
    );
  }

  private getComponentProps(): ProjectOfflineInvestorsFormComponentProps {
    return {
      handleChange: (key: string) => this.handleChange(key),
      handleSubmit: () => this.handleSubmit(),
      project: this.props.project!,
      newOfflineInvestor: this.state.offlineInvestor!,
      success: this.state.success!,
      errorMessage: this.props.errorMessage,
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
    createOfflineInvestor: (projectId: string, offlineInvestor: OfflineInvestor):
      Promise<CreateOfflineInvestorAction> => (
        dispatch(createOfflineInvestor(projectId, offlineInvestor))
      ),
    changeProjectData: (project: ProjectData): ChangeProjectDataAction => (
      dispatch(changeProjectData(project))
    )
  });

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  error: state.createOfflineInvestor.error,
  errorMessage: state.createOfflineInvestor.errorMessage,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectOfflineInvestorsFormContainer);



// WEBPACK FOOTER //
// ./src/modules/project/update/partials/round-information/ProjectOfflineInvestorsForm.container.tsx